import type {AgentRequestOptions} from '../../../../types'

export const agentPageOptions: AgentRequestOptions = {
  cloudInfo: true,
  tabs: true,
}
